import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  RELOAD_TESTS: "relaod_tests",
  SET_TESTS_LOADED: "set_tests_loaded",
  TOGGLE_TEST_LIST: "toggle_list_version",
  CHANGE_FILTER_TESTS: "change_filter_tests",
};
export const INITIAL_STATE = {
  tests: {
    filter: {
      type: null,
    },
    elements: [],
    status: STATUS_NOT_LOADED,
  },
  tests_id_deploy: [],
};

export const testsReducer = (state, action) => {
  const {
    RELOAD_TESTS,
    SET_TESTS_LOADED,
    TOGGLE_TEST_LIST,
    CHANGE_FILTER_TESTS,
  } = types;
  switch (action.type) {
    case RELOAD_TESTS:
      return {
        ...state,
        tests: { ...state.tests, status: STATUS_NOT_LOADED },
      };
    case SET_TESTS_LOADED:
      return {
        ...state,
        tests: {
          ...state.tests,
          status: LOADED,
          elements: action.payload,
        },
      };
    case TOGGLE_TEST_LIST:
      const is_deployed = state.tests_id_deploy.includes(action.payload);
      return {
        ...state,
        tests_id_deploy: is_deployed
          ? state.tests_id_deploy.filter(
              (test_id) => test_id !== action.payload
            )
          : [...state.tests_id_deploy, action.payload],
      };
    case CHANGE_FILTER_TESTS:
      return {
        ...state,
        tests: {
          ...state.tests,
          filter: {
            ...state.tests.filter,
            [action.payload.field]: action.payload.value,
          },
        },
      };

    default:
      return state;
  }
};
